export default __webpack_public_path__ + "static/media/shoe_leader.58977f73.svg";